
import { useState } from "react";
export default function Header() {
    const [ShowContractInfo, setShowContractInfo] = useState(false);
    return (
        <div>
        <div className="contact">
            Alessandro Gagliardi <p onClick={() => setShowContractInfo(true)} >Contract No: 00001</p>
        </div>
        {ShowContractInfo && (
        <div
          className="section-overlay"
          onClick={() => setShowContractInfo(false)}
        >
          <div
            className="overlay-box"
            onClick={(e) => e.stopPropagation()}
          >
            <h3>Contract Info</h3>

                    {/* RADIO VALUTA */}
                    <div>
                        <p>Contract No: 00001</p>
                        <p>Name: Alessandro </p>
                        <p>Last Name: Gagliardi </p>
                        <p>Fiscal Code: XXXXXXXXXXXXXXX </p>
                        <p>ISIN Code: XXXXXXXXX </p>
                        <p>Historical Return:  </p>
                        <p>Percentage Return: 3,8 % </p>
                    </div>

            {/* PULSANTI MODAL */}
            <div className="modal-buttons">
              <button
                className="modal-btn confirm"
                onClick={() => {
                    setShowContractInfo(false);
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
        </div>
    );
}